import React from 'react';

const Svg = ({ children, className = 'h-5 w-5', ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
);

export const HomeIcon = (props) => (
  <Svg {...props}>
    <path d="m3 11 9-8 9 8" />
    <path d="M5 10v10h14V10" />
    <path d="M10 20v-6h4v6" />
  </Svg>
);

export const BriefcaseIcon = (props) => (
  <Svg {...props}>
    <path d="M10 6V5a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v1" />
    <rect x="4" y="6" width="16" height="14" rx="2" />
    <path d="M9 6v14" />
    <path d="M15 6v14" />
  </Svg>
);

export const UsersIcon = (props) => (
  <Svg {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </Svg>
);

export const BarChartIcon = (props) => (
  <Svg {...props}>
    <path d="M3 3v18h18" />
    <path d="M7 16V9" />
    <path d="M12 16V5" />
    <path d="M17 16v-3" />
  </Svg>
);

export const CreditCardIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 10h18" />
  </Svg>
);

export const DollarIcon = (props) => (
  <Svg {...props}>
    <path d="M12 2v20" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </Svg>
);

export const UserIcon = (props) => (
  <Svg {...props}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </Svg>
);

export const EyeIcon = (props) => (
  <Svg {...props}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);

export const EyeOffIcon = (props) => (
  <Svg {...props}>
    <path d="M3 3l18 18" />
    <path d="M10.6 10.6a3 3 0 0 0 4.2 4.2" />
    <path d="M9.9 4.2A10.4 10.4 0 0 1 12 4c6.5 0 10 8 10 8a18.5 18.5 0 0 1-2.2 3.4" />
    <path d="M6.1 6.1C3.5 7.9 2 12 2 12s3.5 8 10 8a10.7 10.7 0 0 0 5.9-1.9" />
  </Svg>
);

export const ShieldIcon = (props) => (
  <Svg {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
  </Svg>
);

export const LogOutIcon = (props) => (
  <Svg {...props}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </Svg>
);

export const QrIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="3" width="5" height="5" />
    <rect x="16" y="3" width="5" height="5" />
    <rect x="3" y="16" width="5" height="5" />
    <path d="M12 4h1" />
    <path d="M12 8h1" />
    <path d="M12 12h2" />
    <path d="M16 12h1" />
    <path d="M20 12h1" />
    <path d="M12 16h1" />
    <path d="M16 16h5" />
    <path d="M12 20h1" />
    <path d="M16 20h1" />
    <path d="M20 20h1" />
  </Svg>
);

export const BusinessCardIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="14" rx="3" />
    <circle cx="8.5" cy="10" r="2" />
    <path d="M5.5 16a3.5 3.5 0 0 1 6 0" />
    <path d="M14 9h4" />
    <path d="M14 13h5" />
    <path d="M14 16h3" />
    <path d="M7 5.5 9.5 3" />
    <path d="M10.5 5.5 13 3" />
  </Svg>
);

export const BusinessCardIconFilled = ({ className, ...props }) => (
  <Svg
    className={className}
    fill="currentColor"
    stroke="none"
    {...props}
  >
    <defs>
      <mask id="businessCardMask">
        <rect x="2" y="5" width="20" height="14" rx="2" fill="white" />
        <circle cx="8" cy="10" r="2.2" fill="black" />
        <path
          d="M4.5 16.5c0-2 1.8-3.5 3.5-3.5s3.5 1.5 3.5 3.5"
          fill="black"
        />
        <rect x="13" y="9.3" width="6" height="1.5" rx="0.75" fill="black" />
        <rect x="13" y="12.3" width="4.5" height="1.5" rx="0.75" fill="black" />
      </mask>
    </defs>

    <rect x="2" y="5" width="20" height="14" rx="2" mask="url(#businessCardMask)" />
  </Svg>
);

export const PlusIcon = (props) => (
  <Svg {...props}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </Svg>
);

export const SearchIcon = (props) => (
  <Svg {...props}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </Svg>
);

export const FilterIcon = (props) => (
  <Svg {...props}>
    <path d="M3 5h18" />
    <path d="M7 12h10" />
    <path d="M10 19h4" />
  </Svg>
);

export const MoreVerticalIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="19" r="1" />
  </Svg>
);

export const CalendarIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4" />
    <path d="M8 2v4" />
    <path d="M3 10h18" />
  </Svg>
);

export const CalendarIconFilled = ({ className, ...props }) => (
  <Svg
    className={className}
    fill="currentColor"
    stroke="none"
    {...props}
  >
    <defs>
      <mask id="calendarMask">
        <rect x="3" y="4" width="18" height="17" rx="2" fill="white" />
        <rect x="7" y="2" width="1.8" height="4" rx="0.9" fill="black" />
        <rect x="15.2" y="2" width="1.8" height="4" rx="0.9" fill="black" />
        <rect x="6" y="9" width="2.8" height="2.8" rx="0.6" fill="black" />
        <rect x="10.6" y="9" width="2.8" height="2.8" rx="0.6" fill="black" />
        <rect x="15.2" y="9" width="2.8" height="2.8" rx="0.6" fill="black" />
        <rect x="6" y="14" width="2.8" height="2.8" rx="0.6" fill="black" />
        <rect x="10.6" y="14" width="2.8" height="2.8" rx="0.6" fill="black" />
        <rect x="15.2" y="14" width="2.8" height="2.8" rx="0.6" fill="black" />
      </mask>
    </defs>

    <rect x="3" y="4" width="18" height="17" rx="2" mask="url(#calendarMask)" />
  </Svg>
);

export const TrendingIcon = (props) => (
  <Svg {...props}>
    <path d="m3 17 6-6 4 4 8-8" />
    <path d="M14 7h7v7" />
  </Svg>
);

export const ClockIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </Svg>
);

export const ArrowUpIcon = (props) => (
  <Svg {...props}>
    <path d="m7 17 10-10" />
    <path d="M7 7h10v10" />
  </Svg>
);

export const MenuIcon = (props) => (
  <Svg {...props}>
    <path d="M4 6h16" />
    <path d="M4 12h16" />
    <path d="M4 18h16" />
  </Svg>
);

export const BuildingIcon = (props) => (
  <Svg {...props}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <path d="M9 7h1" />
    <path d="M14 7h1" />
    <path d="M9 11h1" />
    <path d="M14 11h1" />
    <path d="M9 15h1" />
    <path d="M14 15h1" />
  </Svg>
);

export const MailIcon = (props) => (
  <Svg {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </Svg>
);

export const PhoneIcon = (props) => (
  <Svg {...props}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.59 2.61a2 2 0 0 1-.45 2.11L8 9.69a16 16 0 0 0 6.31 6.31l1.25-1.25a2 2 0 0 1 2.11-.45c.84.27 1.71.47 2.61.59A2 2 0 0 1 22 16.92z" />
  </Svg>
);

export const GlobeIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 0 1 0 20" />
    <path d="M12 2a15.3 15.3 0 0 0 0 20" />
  </Svg>
);

export const MapPinIcon = (props) => (
  <Svg {...props}>
    <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0z" />
    <circle cx="12" cy="10" r="3" />
  </Svg>
);

export const EditIcon = (props) => (
  <Svg {...props}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </Svg>
);

export const TrashIcon = (props) => (
  <Svg {...props}>
    <path d="M3 6h18" />
    <path d="M8 6V4h8v2" />
    <path d="M19 6l-1 14H6L5 6" />
    <path d="M10 11v5" />
    <path d="M14 11v5" />
  </Svg>
);

export const ArrowLeftIcon = (props) => (
  <Svg {...props}>
    <path d="M19 12H5" />
    <path d="m12 19-7-7 7-7" />
  </Svg>
);

export const Alert = (props) => (
  <Svg {...props}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </Svg>
);

export const CheckIcon = ({ className = "h-5 w-5 flex-shrink-0", ...props }) => (
  <Svg
    viewBox="0 0 20 20"
    fill="currentColor"
    stroke="none"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </Svg>
);

export const CheckCircle = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </Svg>
);

export const XCircle = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m15 9-6 6" />
    <path d="m9 9 6 6" />
  </Svg>
);
